<template>
  <div
    v-if="count > 0 && limits.length > 0 && count > limits[0] && filtered.length > 1"
    class="btn-group"
  >
    <button
      v-for="limit in filtered"
      :key="limit"
      type="button"
      class="btn"
      :class="{ 'btn-warning': value === limit, 'btn-default': value !== limit }"
      @click="$emit('input', limit)"
    >
      {{ limit }}
    </button>
  </div>
</template>

<script>

/**
 * Кнопки для выбора максимального количества отображаемых на одной страницы пагинации элементов.
 */
export default {
  name: 'LimitButtonsGroup',
  props: {
    /**
     * Текущее значение.
     *
     * @model
     */
    value: {
      type: Number,
      required: true
    },
    /**
     * Возможные значения.
     */
    limits: {
      type: Array,
      required: true
    },
    /**
     * Общее количество элементов.
     */
    count: {
      type: Number,
      required: true
    }
  },
  computed: {
    /**
     * Возможные значения лимитов с учетом общего количества элементов.
     *
     * Например, если общее количество элементов меньше, чем одно из возможных значений лимитов,
     * то такое возможное значение будет исключено.
     *
     * @returns {*[]}
     */
    filtered () {
      const filtered = this.limits.filter((limit) => this.count >= limit)

      // Обновляем текущее значение лимита, если оно не соответствует количеству элементов
      if (!filtered.includes(this.value)) {
        let newLimit = this.value

        for (const limit of this.limits) {
          if (this.count > limit) {
            newLimit = limit
          }
        }

        /**
         * Вызывается при изменении значения.
         *
         * @property {Number} value Лимит.
         */
        this.$emit('input', newLimit)
      }

      return filtered
    }
  }
}
</script>

<style scoped>
.btn-group {
  margin-bottom: 15px;
}
</style>
